import React from "react";
import ProductDetails from "shared/product-details";
import { normalizeApi } from "shared/api";

export default class StartupsProductDetails extends React.PureComponent {
  render() {
    const product = normalizeApi(this.props.product, "product");

    return (
      <div>
        <ProductDetails {...this.props} product={product} isMerchant={false} />
      </div>
    );
  }
}
